import {Injectable} from '@angular/core';

@Injectable()
export class CommandsDataFileSystem {
    constructor() {

    }

    changeDir() {
    }

    closeDir() {
    }

    closeFile() {
    }

    copyFile() {
    }

    createDir() {
    }

    currentDir() {
    }

    deleteDir() {
    }

    deleteFile() {
    }

    eof() {
    }

    filePos() {
    }

    fileSize() {
    }

    fileType() {
    }

    moreFiles() {
    }

    nextFile() {
    }

    openFile() {
    }

    readAvail() {
    }

    readByte() {
    }

    readDir() {
    }

    readFile() {
    }

    readFloat() {
    }

    readInt() {
    }

    readLine() {
    }

    readShort() {
    }

    readString() {
    }

    seekFile() {
    }

    writeByte() {
    }

    writeFile() {
    }

    writeFloat() {
    }

    writeInt() {
    }

    writeLine() {
    }

    writeShort() {
    }

    writeString() {
    }
}
